/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface BrandMenuMenuIdRePublishPut$Params {
  'Active-Tenant-Identifier': string;
  menuId: string;

/**
 * env we want to publish the changes to
 */
  publishTarget?: string;
}

export function brandMenuMenuIdRePublishPut(http: HttpClient, rootUrl: string, params: BrandMenuMenuIdRePublishPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, brandMenuMenuIdRePublishPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('menuId', params.menuId, {});
    rb.query('publishTarget', params.publishTarget, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

brandMenuMenuIdRePublishPut.PATH = '/brand-menu/{menuId}/re-publish';
